import { FC } from 'react';

import { Breakpoints } from '@lichtblick/theme';

import { useSliderState } from './BasicSlider';
import { NextButton, PrevButton } from './SliderNavigationButtons.styles';

type SliderNavigationButtonsProps = {
  'data-testid-prefix'?: string;
  numPages: { [B in Breakpoints]?: number } & { mobile: number };
};

export const SliderNavigationButtons: FC<SliderNavigationButtonsProps> = ({
  'data-testid-prefix': prefix,
  numPages,
}) => {
  const { isBeginning, isEnd, swiper } = useSliderState();

  return (
    <>
      <PrevButton
        $isDisabled={isBeginning}
        $numPages={numPages}
        aria-disabled={isBeginning}
        aria-label="eine Folie zurückschalten"
        className="custom-prev"
        data-testid={prefix && `${prefix}-previous-slide`}
        onClick={() => swiper.slidePrev()}
        role="button"
      />
      <NextButton
        $isDisabled={isEnd}
        $numPages={numPages}
        aria-disabled={isEnd}
        aria-label="eine Folie weiterschalten"
        className="custom-next"
        data-testid={prefix && `${prefix}-next-slide`}
        onClick={() => swiper.slideNext()}
        role="button"
      />
    </>
  );
};
